<template>
	<v-data-table
    :headers="headers"
    :items="listToComponent"
    :items-per-page="30"
    class="elevation-1 fill-height"
    :height="currentHeight"
  >
  	<template v-slot:item.path="{item}">
  		<v-img
  			contain
  			width="100"
  			height="80"
  			:aspect-ratio="16/9"
  			:src="$Helper.check_img(item.path,$URL)"
  		></v-img>
  	</template>
  	<template v-slot:item.similarity="{item}">
  		{{ parseInt(item.similarity * 100)}} %
  	</template>
  </v-data-table>
</template>
<script type="text/javascript">
	export default{
		name : "TableSearchByVideo",
		props : ["listToComponent", "currentHeight"],
		data : (vm)=>({
			headers:[
				{ text : vm.$ml.get("face"), value: "path"},
				{ text : vm.$ml.get("similarity"), value: "similarity"},

				{ text : vm.$ml.get("time"), value: "currentTime"},
				{ text : vm.$ml.get("faces"), value: "infovideo.total_faces"},

			]
		})
	}
</script>